import { FormMoneyInput } from "../Input";
import { AmountInputWrapper, Card, CardLabel } from "./styles";
import { AmountCardProps, AmountFieldValues } from "./types";

export const AmountCard = <TValues extends AmountFieldValues>({
  id,
  label,
  control,
  rules,
  tone,
  disabled,
  required,
  children,
}: AmountCardProps<TValues>) => (
  <Card>
    <CardLabel htmlFor={id}>{label}</CardLabel>
    <AmountInputWrapper $tone={tone}>
      <FormMoneyInput
        id={id}
        required={required}
        name="amount"
        control={control}
        rules={rules}
        placeholder="0.00"
        disabled={disabled}
        variant="title"
        autoFocus={true}
      />
    </AmountInputWrapper>
    {children}
  </Card>
);
